import type { ApiComponents } from '@aztec-realms/api-client';

export type AvatarCatalogFixture = ApiComponents['schemas']['AvatarCatalogResponse'];

/**
 * Credential-free, deterministic presentation data for canonical browser captures.
 * Production and ordinary demo play continue to load the server-authoritative catalogue.
 */
export const avatarCatalogVisualFixture: AvatarCatalogFixture = {
  current_asset_id: 'portrait_wayfinder_citlali_v1',
  level: 1,
  avatars: [
    {
      asset_id: 'portrait_wayfinder_citlali_v1',
      label: 'Dawn Wayfinder',
      description: 'A patient pathfinder prepared for the first lakeside journey.',
      asset_url: '/assets/portraits/wayfinder-citlali-v1.png',
      unlock_level: 1,
      unlocked: true,
      selected: true,
      review_status: 'needs_cultural_review',
      provenance: 'openai_builtin_imagegen_v1',
    },
    {
      asset_id: 'portrait_canal_keeper_v1',
      label: 'Canal Keeper',
      description: 'A waterway steward who reads the changing current.',
      asset_url: '/assets/portraits/canal-keeper-v1.webp',
      unlock_level: 5,
      unlocked: false,
      selected: false,
      review_status: 'needs_cultural_review',
      provenance: 'openai_builtin_imagegen_v1',
    },
    {
      asset_id: 'portrait_obsidian_artisan_v1',
      label: 'Obsidian Artisan',
      description: 'A precise maker whose craft supports difficult restorations.',
      asset_url: '/assets/portraits/obsidian-artisan-v1.webp',
      unlock_level: 10,
      unlocked: false,
      selected: false,
      review_status: 'needs_cultural_review',
      provenance: 'openai_builtin_imagegen_v1',
    },
    {
      asset_id: 'portrait_garden_steward_v1',
      label: 'Garden Steward',
      description: 'A civic grower who brings terraces and courtyards to life.',
      asset_url: '/assets/portraits/garden-steward-v1.webp',
      unlock_level: 18,
      unlocked: false,
      selected: false,
      review_status: 'needs_cultural_review',
      provenance: 'openai_builtin_imagegen_v1',
    },
    {
      asset_id: 'portrait_codex_keeper_v1',
      label: 'Codex Keeper',
      description: 'A careful interpreter of connected glyph families.',
      asset_url: '/assets/portraits/codex-keeper-v1.webp',
      unlock_level: 28,
      unlocked: false,
      selected: false,
      review_status: 'needs_cultural_review',
      provenance: 'openai_builtin_imagegen_v1',
    },
    {
      asset_id: 'portrait_sky_observer_v1',
      label: 'Sky Observer',
      description: 'A horizon reader attuned to celestial changes across the realm.',
      asset_url: '/assets/portraits/sky-observer-v1.webp',
      unlock_level: 40,
      unlocked: false,
      selected: false,
      review_status: 'needs_cultural_review',
      provenance: 'openai_builtin_imagegen_v1',
    },
  ],
};
